var _path, _circle, _path2, _circle2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteRaters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0132 11.75L13.6425 20.863C13.7085 21.2322 13.5624 21.6072 13.2642 21.8345L11.356 23.2883C10.998 23.561 10.502 23.561 10.144 23.2883L8.24447 21.841C7.94169 21.6103 7.79613 21.2278 7.869 20.8542L9.64474 11.75",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 5.75,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1366 16.25C17.3529 13.5411 14.263 11.75 10.75 11.75C5.22715 11.75 0.75 16.1767 0.75 21.6372V24.9242C0.75 25.4151 1.10638 25.8334 1.59109 25.9115L2.90305 26.1226C7.31991 26.8335 11.8109 26.9403 16.25 26.4428",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.25,
    cy: 23.25,
    r: 8.5,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 19.25V27.25",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2549 23.245L20.2549 23.245",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteRaters);
export default __webpack_public_path__ + "static/media/invite-raters.7600b5b3ed2d8e606e903d2483fe58e0.svg";
export { ForwardRef as ReactComponent };